import React from 'react';

const IconFavouriteUnselected = ({ size = 50, ...props }) => {
    return (
        <svg
            width={size}
            viewBox='0 0 50 47.571'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path d='M24.899 9.312l4.048 8.3c.608 1.214 1.822 2.024 3.037 2.226l9.11 1.417-6.681 6.478c-1.012 1.012-1.417 2.227-1.215 3.644l1.62 9.109-8.097-4.251c-.608-.405-1.215-.405-1.822-.405-.608 0-1.215.202-1.822.405l-8.097 4.25 1.62-9.108c.202-1.215-.203-2.632-1.215-3.644l-6.68-6.478 9.109-1.417c1.417-.202 2.429-1.012 3.036-2.227l4.049-8.3m0-9.311l-7.693 15.587L0 18.219l12.55 12.145-3.036 17.207L24.9 39.474l15.384 8.097-2.834-17.207L50 18.22l-17.206-2.43z' />
        </svg>
    );
};

export default IconFavouriteUnselected;
